import script from "./EditQueryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQueryDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditQueryDialog.vue?vue&type=style&index=0&id=11cee21c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cee21c"]])

export default __exports__